import { useState } from "react";
import { api } from "../../../../service/api";

export function useUpdateStatusMovement() {
  const [isLoadingUpdate, setIsLoadingUpdate] = useState(false);

  const updateStatusMovement = async (id: string, status: string) => {
    try {
      setIsLoadingUpdate(true);
      await api.put("/company/frota/movement/status/" + id, { status });
    } catch (error) {
      throw error;
    } finally {
      setIsLoadingUpdate(false);
    }
  };

  return { isLoadingUpdate, updateStatusMovement };
}
